const fromAppointmentQueryToAppointment = (data)=>{
    if (!data) {
        return null;
    }
    const { id , invitee , appointmentType , startTime , endTime , storeInfo , child , preferredChannelOfCommunication ,  } = data;
    var _lastName, _lastName1;
    return {
        id,
        endTime: new Date(endTime),
        startTime: new Date(startTime),
        invitee: invitee ? {
            firstName: invitee.firstName,
            lastName: (_lastName = invitee.lastName) !== null && _lastName !== void 0 ? _lastName : undefined
        } : undefined,
        appointmentType: appointmentType ? {
            id: appointmentType.id,
            name: appointmentType.name,
            description: appointmentType.description,
            ageGroup: appointmentType.ageGroup,
            duration: {
                amount: appointmentType.duration.amount,
                unit: appointmentType.duration.unit
            },
            isVisibleToCustomers: appointmentType.visibleToCustomers
        } : undefined,
        storeInfo: storeInfo ? {
            globalStoreId: storeInfo.globalStoreId
        } : undefined,
        child: child ? {
            firstName: child.firstName,
            lastName: (_lastName1 = child.lastName) !== null && _lastName1 !== void 0 ? _lastName1 : undefined
        } : undefined,
        preferredChannelOfCommunication: preferredChannelOfCommunication !== null && preferredChannelOfCommunication !== void 0 ? preferredChannelOfCommunication : undefined
    };
};

export { fromAppointmentQueryToAppointment };
//# sourceMappingURL=fromAppointmentQueryToAppointment.js.map
